let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eLwwW")).then(() => parcelRequire('e3biM'));